<template>
  <div>
    <div class="profile__container">
      <div class="profile__col1">
        <div class="profile__col1Body">
          <div class="profile__headers">
            <img
              :src="require('../../assets/cuisines/no_image.jpg')"
              alt="profile"
            />

            <div class="profile__headersText">
              <span> Namaste!</span>
              <span>Welcome, {{ this.loggedUser.first_name }} </span>
            </div>
          </div>
          <div class="profile__col1logout" @click="logout()">Log Out</div>
          <div class="profile__items">
            <div class="profile__item">
              <img :src="require('../../assets/svg/myorder.svg')" />
              <div class="items__myorder">My Orders</div>
              <div class="items__orderQuantity">
                {{ this.loggedUser.total_orders }}
              </div>
            </div>
            <div class="profile__item">
              <img :src="require('../../assets/photos/chilly1.png')" />
              <div class="items__myorder">Chillies</div>
              <div class="items__orderQuantity">
                {{ this.loggedUser.total_point }}
              </div>
            </div>
          </div>
        </div>

        <!-- <div class="profile__col1logout" @click="logout()">
          Log Out
        </div> -->
      </div>
      <div class="profile__col2">
        <h2>PREVIOUS ORDERS</h2>

        <div v-if="this.loading" class="myAccount__loading"><Loading /></div>

        <div class="profile__main" v-else>
          <div
            class="profile__body"
            v-for="items in orderItems"
            :key="items.id"
          >
            <div class="profile__order-date">
              <span>#{{ items.id }}</span>

              <span>{{ items.order_receive_date }}</span>
            </div>
            <div class="profile__orderBody">
              <div
                class="profile__orderItems"
                v-for="item in items.order"
                :key="item.id"
              >
                <div>{{ item.item_name }}</div>
                <div>x{{ item.qty }}</div>
                <div class="price">
                  <span> Rs. {{ item.unit_price }}/-</span>
                </div>
              </div>

              <div class="profile__orderItems">
                <div>Delivery Charge</div>
                <!-- <div>x2</div> -->
                <div class="pricedel">
                  <span> {{ items.delivery_charge }}</span>
                </div>
              </div>

              <div class="profile__grandTotal">
                <div>Grand Total</div>
                <!-- <div>x2</div> -->
                <div class="grandtotal">
                  <span> Rs. {{ items.grand_total }}/-</span>
                </div>
              </div>
            </div>
            <div class="order__status">
              <!-- <button>Reorder</button> -->
              <button @click="handleFeedback(items.id)">Give Feedback</button>
              <span> {{ getStatusText(items.order_status) }}</span>
            </div>
          </div>

          <div v-if="this.orderItems.length == 0" class="order__empty">
            <div>Seems like you haven't ordered before.</div>
            <button @click="onHome()">Order Now</button>
          </div>
        </div>
      </div>
    </div>
    <FooterBar />
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { GetUserCarts } from "../../services/user.service";
import FooterBar from "../../components/FloatingFooter/FooterBar";
import Loading from "../../components/Loading/Loading.vue";
import axios from "axios";
import { LocationId } from "../../services/storage.service";

import router from "../../router";

export default {
  name: "MyAccount",
  components: {
    // BannerSlider,
    FooterBar,
    Loading,
  },
  data() {
    return {
      orderItems: [],
      loading: true,
      newFeedbackUrl: "",
    };
  },
  computed: {
    ...mapGetters(["loggedIn", "loggedUser", "loggedInApp"]),
  },

  created() {
    window.scrollTo(0, 0);

    if (this.loggedIn) this.loadUserOrder();
    if (this.loggedInApp) this.loadUserItems();
    this.megamenu(LocationId.getLocationId());

    this.getCartLength();
  },

  watch: {
    loggedIn: function (n, o) {
      if (this.loggedIn) this.loadUserOrder();
    },

    loggedInApp: function (n, o) {
      if (this.loggedInApp) this.loadUserItems();
    },
  },
  methods: {
    ...mapActions(["logout", "megamenu"]),

    loadUserOrder: function () {
      GetUserCarts.getItems(parseInt())
        .then((res) => {
          // console.log("category my account", res);
          this.orderItems = res.data;
          this.loading = false;
        })
        .catch((err) => {
          // this.loading = false;
          console.log(err);
        });
    },

    loadUserItems: function () {
      GetUserCarts.getItemSocial(parseInt())
        .then((res) => {
          // console.log("category my account", res);
          this.orderItems = res.data;
          this.loading = false;
        })
        .catch((err) => {
          // this.loading = false;
          console.log(err);
        });
    },

    getCartLength() {
      if (this.orderItems.length == 0) {
        // this.loading = false;
      }
    },

    getStatusText: function (status) {
      // console.log(status);
      switch (Number(status)) {
        case 2:
        case 3:
          return "Awaiting Confirmation";
          break;
        case 1:
          return "Confirmed";
          break;
        case 4:
          return "In Kitchen";
          break;
        case 5:
        case 6:
          return "In Route";
          break;

        case 0:
          return "Cancelled";
          break;

        case 9:
          return "Closed";
          break;

        default:
          return "Undefined";
      }
    },

    handleFeedback(id) {
      axios
        .post("https://deus.khaanpin.com/om/genpaylink/", { cart_id: id })
        .then((res) => {
          if (!res.data.error) {
            const feedbackUrl = res.data.data;

            var token = feedbackUrl.substring(
              feedbackUrl.indexOf("t=") + 2,
              feedbackUrl.indexOf("c=") + -1
            );
            var code = feedbackUrl.substring(feedbackUrl.indexOf("c=") + 2);
          }

          window.open(
            `https://khaanpin.com.np/infeed/#/cif?t=${token}&c=${code}`,
            "_blank"
          );
        })
        .then((err) => {
          console.log(err);
        });
    },

    onFeedback(t, c) {
      window.open("https://khaanpin.com.np/infeed/#/cif?t=${t}&c=${c}");
    },

    onHome() {
      router.push("/");
    },
  },
};
</script>

<style scoped>
@import url("https://fonts.googleapis.com/css2?family=Lato:wght@400;700&family=Montserrat&family=Roboto:wght@500&display=swap");

.profile__container {
  display: flex;
  font-family: "Montserrat", sans-serif;
  min-height: 90vh;
}

.profile__col1 {
  flex: 2.5;
  /* border: 1px solid black; */
  border-right: 1px solid #cecece;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  padding: 0.5%;
}

.profile__col1Body {
  /* border: 1px solid black; */
  width: 80%;
}

.profile__headers {
  display: flex;
  align-items: center;
}

.profile__headers > img {
  height: 75px;
  width: 75px;
  border-radius: 50%;
  /* border: 1px solid red; */
  box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16), 0 3px 6px rgba(0, 0, 0, 0.23);
}

.profile__headersText {
  display: flex;
  flex-direction: column;
  /* color: #ed3c3b; */
  color: #505050;

  margin: 0 25px;
}

.profile__headersText > span:nth-child(1) {
  font-weight: bolder;
  font-size: 22px;
  letter-spacing: 0.5px;
}

.profile__headersText > span:nth-child(2) {
  font-size: 15px;
  font-weight: bolder;
  letter-spacing: 0.5px;
}

.profile__items {
  /* border: 1px solid black; */
  margin: 15% 0;
}

.profile__item {
  display: flex;
  align-items: center;
  margin: 1% 0;
  color: #505050;
  font-weight: bolder;
  font-size: 16px;
}

.profile__item > img {
  height: 40px;
}

.items__myorder {
  width: 65%;
  margin-left: 8px;
}

.items__orderQuantity {
  /* border: 1px solid black; */
  width: 10px;
}

.profile__col1logout {
  color: #ed3c3b;
  font-size: 16px;
  font-weight: bolder;
  text-decoration: underline;
  cursor: pointer;
  margin-bottom: 30px;
  /* border: 1px solid black; */
  text-align: center;
}

.profile__col1logout:hover {
  color: red;
}

.profile__col2 {
  flex: 9.5;
  /* border: 1px solid rgb(202, 30, 30); */
  display: flex;
  padding: 0.5%;
  display: flex;
  flex-direction: column;
  margin-left: 6%;
  /* justify-content: flex-start; */
  /* align-items: center; */
}

.myAccount__loading {
  /* border: 1px solid black; */
  width: 60%;
  height: 40%;
}

.profile__col2 > h2 {
  color: #ed3c3b;
  font-weight: bolder;
  font-size: 22px;
  letter-spacing: 0.8px;
  margin-top: 10px;
  /* text-decoration: underline; */
}

.profile__body {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  border: 1px solid #f3f1f1;
  /* border: 1px solid black; */
  /* height: 400px; */
  width: 100%;
  background-color: white;
  /* padding: 0.5%; */
  padding: 10px 8px;
  margin: 15px 0;
  border-radius: 10px;
}

.profile__main {
  /* border: 1px solid black; */
  width: 60%;
  /* margin-right: 100px; */
  overflow: scroll;
  overflow-x: hidden;
  padding-right: 12px;
  margin-bottom: 10px;
}

.profile__order-date {
  display: flex;
  justify-content: space-between;
  align-items: center;
  /* border: 1px solid black; */
  width: 100%;
  margin: 5px 0;
  font-family: "Montserrat", sans-serif;
}

.profile__order-date > span:nth-child(1) {
  color: #ed3c3b;
  font-size: 14px;
  font-weight: bolder;
}

.profile__orderBody {
  /* border: 1px solid red; */
  width: 100%;
  border-radius: 12px;
  padding: 8px 5px;
  background-color: #f3f3f3;
  display: flex;
  flex-direction: column;
}

.profile__orderItems {
  /* color: red; */
  /* border: 1px solid black; */
  padding-left: 8px;
  display: flex;
  margin: 4px 0;
}

.profile__grandTotal {
  padding-left: 8px;
  display: flex;
  margin: 4px 0;
  border-top: 1px solid rgb(175, 175, 175);
  padding-top: 10px;
}

.price {
  /* color: red; */
  /* border: 1px solid red; */
  width: 100%;
  display: flex;
  justify-content: end;
  /* font-weight: bolder; */
  margin-right: 5px;
}

.pricedel {
  width: 100%;
  display: flex;
  justify-content: end;
  margin-right: 5px;
}

.grandtotal {
  width: 100%;
  display: flex;
  justify-content: end;
  margin-right: 5px;
  /* color: red; */
  font-weight: bolder;
}

.profile__grandTotal > div:nth-child(1) {
  margin-right: 8px;
  letter-spacing: 0.3px;
  font-family: "Montserrat", sans-serif;
  width: 40%;
  font-weight: bolder;
}

.profile__orderItems > div:nth-child(1) {
  margin-right: 8px;
  letter-spacing: 0.3px;
  font-family: "Montserrat", sans-serif;
  width: 75%;
  /* border: 1px solid black; */
}

.profile__orderItems > div:nth-child(2),
.profile__grandTotal > div:nth-child(2) {
  /* font-weight: bolder; */
  font-family: "Montserrat", sans-serif;
}

.order__status {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 15px;
  margin-right: 18px;
  margin-top: 5px;
  font-weight: bolder;
  font-family: "Montserrat", sans-serif;
  color: green;
}

.order__status > button {
  /* color: white; */
  color: #ed3c3b;
  /* background: #ed3c3b; */
  background-color: white;

  border: 1px solid #ed3c3b;
  padding: 4px 15px;
  border-radius: 15px;
  margin-left: 5px;
  font-weight: bolder;
  font-size: 14px;
  letter-spacing: 0.5px;
}

.order__status > button:hover {
  background-color: #ed3c3b;
  color: white;
  transition: ease 0.3s all;
}

.order__empty {
  display: flex;
  /* border: 1px solid black; */
  height: 60vh;
  justify-content: center;
  flex-direction: column;
  align-items: center;
}

.order__empty > div {
  color: #505050;
  letter-spacing: 0.6px;
  font-weight: bolder;
  font-family: "Montserrat", sans-serif;
  font-size: 18px;
}

/* .order__empty > button {
  color: #ed3c3b;
  border: 2px solid #ed3c3b;
  padding: 8px 15px;
  background-color: white;
  margin-top: 25px;
  font-weight: bolder;
  border-radius: 18px;
  letter-spacing: 0.5px;
} */

.order__empty > button {
  color: white;
  border: none;
  padding: 10px 15px;
  background-color: #ed3c3b;
  margin-top: 25px;
  font-weight: bolder;
  border-radius: 18px;
  letter-spacing: 0.5px;
}

.order__empty > button:hover {
  background-color: rgb(255, 68, 68);
  transition: 0.8s all;
}

@media only screen and (max-width: 950px) {
  .profile__col1 {
    /* border: 1px solid black; */
    margin-top: 12px;
    padding-bottom: 0px;
  }
  .profile__col2 > h2 {
    /* border: 1px solid black */
    text-align: center;
    font-size: 15px;
  }
  .profile__container {
    display: flex;
    flex-direction: column;
    height: 90vh;
    overflow: scroll;
    /* border: 1px solid black; */
    width: 100%;
  }

  .profile__main {
    /* border: 1px solid black; */
    width: 100%;
    overflow-y: hidden;
  }
}
</style>
